import React , { useEffect, useState} from 'react'

import { resetMapView } from './mapEventHandler.js';
import { entity_language } from '../../entity_language.js';
import ModalEntityViewer  from '../../../components/Modals/ModalEntityViewer/index.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container , Row , Col , Button, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { MapContainer, TileLayer, useMap , Popup , Marker, CircleMarker,  } from 'react-leaflet'
import { DivIcon , Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';


export function ticketMarker (status) {
  let fillColor = 'rgba(var(--bs-danger-rgb), 1)';
  let imagePath = './assets/openTicketMarker.svg';

  switch (status) {
    case '5_OPEN':
      fillColor = 'rgba(var(--bs-danger-rgb), 1)';
      imagePath = './assets/openTicketMarker.svg';
      break;
    case '10_IN_PROGRESS':
      fillColor = 'rgba(var(--bs-warning-rgb), 1)';
      imagePath = './assets/inProgressTicketMarker.svg';
      break;
    case '15_CLOSED':
      fillColor = 'rgba(var(--bs-success-rgb), 1)';
      imagePath = './assets/closedTicketMarker.svg';
      break;
    default:
      fillColor = 'rgba(var(--bs-danger-rgb), 1)';
      imagePath = './assets/openTicketMarker.svg';
  }

  return `<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 501 501">
    <defs>
      <style>
        .cls-1 {
          fill: #fff;
          stroke: rgba(0, 0, 0, 0);
        }

        .cls-2 {
          fill: ${fillColor};
          stroke: #000;
          stroke-width: 40px;
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <circle class="cls-1" cx="250.5" cy="250.5" r="250"/>
      <circle class="cls-2" cx="250.5" cy="250.5" r="160"/>
    </g>
  </svg>`;

};

export default function TicketMap({data , options, disablePopup = false}) {
    console.log('TicketMap - data', data);
    const [mapClass, setMapClass] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState([]);

    function openModal() {
        if( !disablePopup ){
          setShowModal(true)
        }
    }
    
    function closeModal() {
        if( !disablePopup ){
          setShowModal(false)
        }
    }

    useEffect(() => {
        if(data && mapClass) {
            resetMapView(mapClass);
        }
    },[mapClass]);

    if(!data) {
        return (
            <Col className='d-flex justify-content-center align-items-center' style={{minHeight: '60vh'}}>
                <Spinner animation="border" role="status" style={{zIndex: 1000}} >
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </Col>
        )
    }

  return (
    <>
    <MapContainer
            id='lefletTicketMap'
            style={{ width: '100%', height: '100%', minHeight: '75vh', position: 'relative' }}
            bounds={[
              [35.85, 6.72],
              [47.09, 18.78],
            ]}
            zoom={5}
            scrollWheelZoom={options?.scrollWheelZoom !== undefined && options?.scrollWheelZoom !== null ? options.scrollWheelZoom : true}
        >
            <Button onClick={() => resetMapView(mapClass)} variant="primary" className='btn-light border-secondary text-dark position-absolute end-0 m-3' style={{zIndex: 1000}} > 
                <FontAwesomeIcon icon={['fas', 'crosshairs']} />
        </Button>
            <MapClassConverter setMapClass={setMapClass} />
          <TileLayer
            attribution='&copy; <a href="https://www.google.com/maps">Google Maps</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
        {data?.body?.filter( (item) => {if(item?.latitude && item?.longitude) return item; else return false; } ).map((item) => (
          <Marker 
            key={item.id} 
            icon={
               new DivIcon({
                className: `leaflet-ticket-marker marker-status-${item?.status?.value}`,
                iconSize: [30, 30],
                iconAnchor: [15, 15],
                html: (() => ticketMarker(item?.status?.value))() ,
              })
            }
            position={[item?.latitude, item?.longitude]}
            eventHandlers={{
                click: (e) => {
                    // Remove e.preventDefault() and use this instead
                    const marker = e.target;
                    marker.bindPopup(marker.getPopup()).openPopup();
                  },
                }}
          >
            <Popup backgroundColor='white' className='text-dark' style={{ padding: '0.5rem' , borderRadius: '0.5rem' }}>
              <h6>Segnalazione#{item.id}</h6>
              <span className={`badge pill bg-${(()=>{
                switch (item.status.value) {
                    case '5_OPEN':
                        return 'warning';
                    case '10_IN_PROGRESS':
                        return 'secondary';
                    case '15_CLOSED':
                        return 'success';
                    default:
                        return 'warning';
                }
              })()}`} > { entity_language.labels.ticket['status.options.' + item.status.value]} </span>
                <p>{item.description}</p>
                <Button variant="primary" className='me-2' onClick={ () => {setSelectedItem(item); openModal()} }>Dettagli</Button>
                <Button variant="outline-secondary" link={true} as={Link} to={`/entity/ticket/edit?id=${item.id}`}>Modifica</Button>
            </Popup>
          </Marker>
        ))}
        
        </MapContainer>
        <Container>
            <Row>
                <Col className='d-flex justify-content-start align-items-center m-0 p-0 mt-2 gap-2'>
                    <p className='m-0'>Leggenda: </p>
                    <div className='d-flex justify-content-start align-items-center ms-2 gap-2'>
                        <span style={{aspectRatio: '1/1', width: '1rem', height: '1rem', backgroundColor: 'rgba(var(--bs-danger-rgb), 1)', display: 'inline-block'}}></span>
                        <span className='text-muted me-2'>Aperte</span>
                    </div>
                    <div className='d-flex justify-content-start align-items-center ms-2 gap-2'>
                        <span style={{aspectRatio: '1/1', width: '1rem', height: '1rem', backgroundColor: 'rgba(var(--bs-warning-rgb), 1)', display: 'inline-block'}}></span>
                        <span className='text-muted me-2'>In gestione</span>
                    </div>
                    <div className='d-flex justify-content-start align-items-center ms-2 gap-2'>
                        <span style={{aspectRatio: '1/1', width: '1rem', height: '1rem', backgroundColor: 'rgba(var(--bs-success-rgb), 1)', display: 'inline-block' , border: '1px solid rgba(var(--bs-secondary-rgb), 1)'}}></span>
                        <span className='text-muted me-2'>Chiuse</span>
                    </div>
                </Col>
            </Row>
        </Container>
        <ModalEntityViewer item={selectedItem} entity={'ticket'} status={showModal} closeModal={closeModal} />
        </>
  )
}


export function MapClassConverter({setMapClass}) {
    const map = useMap();
    setMapClass(map);
    return null;
}